import { BodyM } from '@/components/Typography'
import { VisuallyHidden } from '@/components/VisuallyHidden'
import { formatCurrency } from '@/core/utils/currency'

import { useLoanSimulatorProvider } from '../../LoanSimulatorProvider'

import { LoanResultStyles } from './styles'

interface Props {
  className?: string
}
const LoanResult = ({ className }: Props) => {
  const { installments, loanInstallmentsResult } = useLoanSimulatorProvider()

  return (
    <LoanResultStyles className={className}>
      <VisuallyHidden aria-live="polite">
        {`Parcela mensal aproximada ${installments} vezes de
        ${formatCurrency(loanInstallmentsResult)}`}
      </VisuallyHidden>

      <div className="results" aria-hidden>
        <BodyM className="title" color="dark-high">
          Parcela mensal aproximada
        </BodyM>
        <BodyM className="installments text-color-primary" aria-hidden>{`${installments}x`}</BodyM>
        <BodyM className="value text-color-primary" tag="span" id="loan-simulation-result" emphasys>
          {formatCurrency(loanInstallmentsResult)}
        </BodyM>
        <BodyM color="dark-high" className="disclaimer">
          Estamos considerando as taxas médias oferecidas pelos parceiros.
        </BodyM>
      </div>
    </LoanResultStyles>
  )
}
export default LoanResult
